module.exports = __webpack_public_path__ + "files/ibm_ws.167e0528.pdf";